// extracted by mini-css-extract-plugin
export default {"container":"Header_container__FE+Oc","noteSelection__container":"Header_noteSelection__container__gw7J1","title":"Header_title__eYluP font-lg-bold"};